<template>
  <!-- <van-button :disabled="!!disabled && leftSecsEnd > 0" :block="block" :size="size" :type="btnType" square @click="onSubmit">{{btnText}}</van-button> -->
  <van-button :block="block" :size="size" :type="btnType" square @click="onSubmit">{{btnText}}</van-button>
</template>

<script>

    import { ERR_NEED_LOGIN, ERR_NEED_MOBILE } from '../store/const.js';
    import {
        mapGetters
    } from 'vuex';

    export default {
        data() {
            return {

            }
        },
        mounted() {},
        props: ['goodsId', 'text', 'size', 'type', 'block', 'step'],
        computed: {
            ...mapGetters(['canBuy', 'chkBuy', 'errorMsg', 'isPre', 'isLast', 'isPayed', 'waitLastId', 'myGidPre', 'myGidLast', 'leftSecsEnd']),
            btnType() {
                return this.type || 'danger'
                // return this.disabled ? 'warning' : this.type || 'danger'
            },
            btnText() {
                let text = this.text
                if(!text) {
                    if(this.goodsId === this.myGidPre) {
                        text = this.myGidLast > 0 ? '抢购成功': '支付尾款'
                    } else {
                        text = '预付定金'
                    }
                }
                // return text + `(${this.status})`
                return text
            },
            buyGoodsId() {
                let goodsId = this.goodsId
                if(this.isPre(goodsId) && this.isPayed(goodsId)) {
                    goodsId = this.waitLastId
                }
                return goodsId
            },
            disabled(){
              return !this.canBuy(this.buyGoodsId) && this.goodsId !== this.myGidPre
            },
            status() {
                return this.chkBuy(this.buyGoodsId)
            }
        },
        methods: {
            onError(err) {
                const {code } = err;
                if(code === ERR_NEED_LOGIN) {
                    this.$dialog.confirm({
                        message: err.message,
                        showConfirmButton: true,
                        confirmButtonText: '去登录'
                    }).then(()=> {
                        this.$store.dispatch('login')
                    })
                } else if(code === ERR_NEED_MOBILE) {
                    this.$dialog.confirm({
                        message: err.message,
                        showConfirmButton: true,
                        confirmButtonText: '去绑定'
                    }).then(()=> {
                        this.$store.dispatch('bindMobile')
                    })
                } else {
                    this.$dialog.confirm({
                        message: err.message,
                        showConfirmButton: true
                    }).then(()=> {
                        // alert(this.goodsId)
                    })
                }
            },
            onSubmit() {
                let status = 0
                //  alert([this.goodsId, this.myGidPre, this.myGidLast])
                if(this.goodsId === this.myGidPre) {
                    if(this.waitLastId > 0) {//支付尾款
                        status = this.chkBuy(this.waitLastId)
                        if(!status) {
                            return this.$store.dispatch('buy', this.waitLastId)
                        }
                        // alert([this.waitLastId, status])
                    } else {// 购买结果页
                      return this.$router.push(`/buy/${this.goodsId}`)
                    }
                    // alert(this.waitLastId)
                } else if(this.disabled) {
                    status = this.status
                } else {
                    if(this.step > 1) {
                        status = this.chkBuy(this.buyGoodsId)
                        if (!status) {
                            return this.$store.dispatch('buy', this.buyGoodsId)
                        }
                        
                    } else {
                        return this.$router.push(`/buy/${this.goodsId}`)
                        // Toast('点击结算');
                    }
                }
                if(status) {
                    this.onError({
                        code : this.status,
                        message: this.errorMsg(this.status)
                    });
                }
            }
        }
    }
</script>
